export const AUTH = {
  loginEmail: "login-email-input",
  loginPassword: "login-password-input",
  loginSubmit: "login-submit-btn",
  loginError: "login-error-message",
  registerEmail: "register-email-input",
  registerPassword: "register-password-input",
  registerName: "register-name-input",
  registerSubmit: "register-submit-btn",
  registerError: "register-error-message",
  gotoRegister: "goto-register-link",
  gotoLogin: "goto-login-link",
  logout: "logout-btn",
};

export const NAV = {
  dashboard: "nav-dashboard",
  tools: "nav-tools",
  categories: "nav-categories",
  locations: "nav-locations",
  transactions: "nav-transactions",
  damage: "nav-damage-reports",
  requests: "nav-tool-requests",
  maintenance: "nav-maintenance",
  users: "nav-users",
};

export const DASH = {
  kpiTotalTools: "kpi-total-tools",
  kpiAvailable: "kpi-available",
  kpiIssued: "kpi-issued",
  kpiPendingUsers: "kpi-pending-users",
  kpiPendingDamage: "kpi-pending-damage",
  kpiPendingRequests: "kpi-pending-requests",
  kpiPendingApprovals: "kpi-pending-approvals",
  kpiMaintenanceOverdue: "kpi-maintenance-overdue",
  kpiMaintenanceDueSoon: "kpi-maintenance-due-soon",
};

export const TOOLS = {
  addBtn: "add-tool-btn",
  saveBtn: "save-tool-btn",
  editBtn: (id) => `edit-tool-${id}`,
  deleteBtn: (id) => `delete-tool-${id}`,
  issueBtn: (id) => `issue-tool-${id}`,
  searchInput: "tools-search-input",
  categoryFilter: "tools-category-filter",
  locationFilter: "tools-location-filter",
  nameInput: "tool-name-input",
  codeInput: "tool-code-input",
  qtyInput: "tool-qty-input",
  descInput: "tool-desc-input",
  binInput: "tool-bin-input",
  conditionSelect: "tool-condition-select",
  categorySelect: "tool-category-select",
  locationSelect: "tool-location-select",
  imageInput: "tool-image-input",
};

export const CAT = {
  addBtn: "add-category-btn",
  saveBtn: "save-category-btn",
  nameInput: "category-name-input",
  descInput: "category-desc-input",
  deleteBtn: (id) => `delete-category-${id}`,
  editBtn: (id) => `edit-category-${id}`,
};

export const LOC = {
  addBtn: "add-location-btn",
  saveBtn: "save-location-btn",
  nameInput: "location-name-input",
  descInput: "location-desc-input",
  binsInput: "location-bins-input",
  deleteBtn: (id) => `delete-location-${id}`,
  editBtn: (id) => `edit-location-${id}`,
};

export const ISSUE = {
  submitBtn: "issue-submit-btn",
  userSelect: "issue-user-select",
  qtyInput: "issue-qty-input",
  dueDateInput: "issue-due-date-input",
  notesInput: "issue-notes-input",
  returnBtn: (id) => `return-txn-${id}`,
  returnSubmit: "return-submit-btn",
  returnCondition: "return-condition-select",
  returnNotes: "return-notes-input",
};

export const DMG = {
  createBtn: "create-damage-btn",
  submitBtn: "damage-submit-btn",
  toolSelect: "damage-tool-select",
  descInput: "damage-desc-input",
  severitySelect: "damage-severity-select",
  photoInput: "damage-photo-input",
  approveBtn: (id) => `approve-damage-${id}`,
  rejectBtn: (id) => `reject-damage-${id}`,
};

export const REQ = {
  createBtn: "create-request-btn",
  submitBtn: "request-submit-btn",
  nameInput: "request-name-input",
  categorySelect: "request-category-select",
  qtyInput: "request-qty-input",
  justificationInput: "request-justification-input",
  urgencySelect: "request-urgency-select",
  approveBtn: (id) => `approve-request-${id}`,
  rejectBtn: (id) => `reject-request-${id}`,
  approveDueDateInput: "approve-request-due-date-input",
  approveNotesInput: "approve-request-notes-input",
  approveSubmitBtn: "approve-request-submit-btn",
};

export const USR = {
  approveBtn: (id) => `approve-user-${id}`,
  rejectBtn: (id) => `reject-user-${id}`,
  deleteBtn: (id) => `delete-user-${id}`,
  roleSelect: (id) => `role-user-${id}`,
};

export const MNT = {
  addBtn: "add-schedule-btn",
  saveBtn: "save-schedule-btn",
  nameInput: "schedule-name-input",
  descInput: "schedule-desc-input",
  daysInput: "schedule-days-input",
  usesInput: "schedule-uses-input",
  toolSelect: "schedule-tool-select",
  serviceBtn: (id) => `service-schedule-${id}`,
  serviceNotesInput: "service-notes-input",
  serviceSubmit: "service-submit-btn",
  deleteBtn: (id) => `delete-schedule-${id}`,
  filterAll: "mnt-filter-all",
  filterOverdue: "mnt-filter-overdue",
  filterDueSoon: "mnt-filter-due-soon",
};
